import PropTypes from 'prop-types'
import { ICON_ORIGINAL_GRAY } from 'constants/colors'

const Facebook = ({ color = ICON_ORIGINAL_GRAY, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 36 36"
    fill={color}
    {...props}
  >
    <path d="M33.8 2C32.5.7 31 0 29.1 0H6.4c-.8 0-1.6.2-2.3.5C1.5 1.8 0 3.8 0 6.7V29c0 1.8.6 3.4 1.9 4.7 1.3 1.3 2.8 2 4.7 2h11.2V21.2c0-.2-.1-.3-.3-.3h-3.1c-.2 0-.3-.1-.3-.3V16c0-.3 0-.3.3-.3h3.1c.3 0 .3 0 .3-.3v-3.2c0-1 .1-2.1.4-3.1.6-1.7 1.8-2.7 3.5-3.1.3-.1.7-.1 1-.2H28v4.9c0 .3 0 .3-.3.3h-2.8c-.2 0-.5 0-.7.1-.6.2-.8.7-.8 1.2v3c0 .2.1.2.3.2h4.1c.2 0 .2.1.2.3-.2 1.6-.3 3.1-.5 4.7 0 .2-.1.2-.3.2h-3.5c-.3 0-.3 0-.3.3V35.4h5.8c.8 0 1.6-.2 2.4-.5 2.6-1.3 4-3.2 4.1-6.2V6.4c0-1.5-.6-3.1-1.9-4.4" />
  </svg>
)

Facebook.propTypes = {
  color: PropTypes.string,
}

export default Facebook
